/**
 * Prompt specialization options for AI widgets.
 * Default is free_text (natural language); use ratings for scale/score-only data.
 */
export const DEFAULT_PROMPT_TYPE = 'free_text';

export const PROMPT_TYPE_OPTIONS = [
  {
    value: 'free_text',
    label: 'Free text & natural language',
    description: 'Use when your data contains open-ended comments, feedback sentences, or rich text. Best for detailed, narrative-style analysis and insights.',
  },
  {
    value: 'ratings',
    label: 'Ratings & scales',
    description: 'Use when your data is mainly scores (e.g. 1–5), scales (Poor to Excellent), or Likert-style responses with little or no free text. The model will infer success vs improvement areas from rating patterns.',
  },
  {
    value: 'workplace_experience',
    label: 'Workplace experience survey',
    description: 'Use for facility / workplace surveys (ratings plus locations, facilities, departments, comments). Produces story-style insights with concrete figures: overall rating and split, best and weakest facility or segment, department gaps, pain points, and prioritized actions. Adapts to whichever of these fields your data actually has.',
  },
];
